import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { buscarCitas, filtarCitas } from '../../actions/citas';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const FiltrosCitas = () => {

    const dispatch = useDispatch();

    const { ventana_filtros } = useSelector(state => state.citas);

    const [statusProcesar, setStatusProcesar] = useState(false);

    const [filtrosData, setFiltrosData] = useState({
        status: null,
        pagada: null,
        fecha_inicio: null,
        fecha_fin: null
    });

    const [statusData, setStatusData] = useState(null);
    const statusFilter = [
        { value: 0, label: 'Agendada' },
        { value: 1, label: 'Finalizada' },
        { value: 2, label: 'Cancelada' }
    ];

    const [pagadaData, setPagadaData] = useState(null);
    const pagosFilter = [
        { value: 1, label: 'Pagada' },
        { value: 0, label: 'Pendiente' }
    ];

    const styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        control: (provided) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px'
        }),
        valueContainer: (provided) => ({
            ...provided,
            overflow: 'visible',
            marginTop: '10px'
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: 'absolute',
            top: state.hasValue || state.selectProps.inputValue ? -15 : '0%',
            transition: 'top 0.1s, font-size 0.1s',
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    const handleSelectStatus = (option) => {
        setStatusData(option);
        setFiltrosData({ ...filtrosData, status: option != null ? option.value : null });
    }

    const handleSelectPagada = (option) => {
        setPagadaData(option);
        setFiltrosData({ ...filtrosData, pagada: option != null ? option.value : null });
    }

    const handleDatePicker = (name, value) => {
        setFiltrosData({ ...filtrosData, [name]: value });
    }

    const handleProcesar = async (limpiar) => {
        await setStatusProcesar(true);

        if(!limpiar){
            await dispatch(buscarCitas(filtrosData));
        } else {
            let datos_base = {
                ...filtrosData,
                status: null,
                pagada: null,
                fecha_inicio: null,
                fecha_fin: null
            };

            await dispatch(buscarCitas(datos_base));
            await setFiltrosData(datos_base);
            await setStatusData(null);
            await setPagadaData(null);
        }

        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            dispatch(filtarCitas(false));
        }
    }

    return (
        <Modal show={ventana_filtros} size="md" backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Filtrar citas</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="status"
                                name="status"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Status"
                                isClearable
                                options={statusFilter}
                                value={statusData}
                                onChange={(value) => handleSelectStatus(value)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="pagada"
                                name="pagada"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Pago"
                                isClearable
                                options={pagosFilter}
                                value={pagadaData}
                                onChange={(value) => handleSelectPagada(value)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_inicio"
                                    name="fecha_inicio"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    selected={filtrosData.fecha_inicio != null ? new Date(filtrosData.fecha_inicio) : ''}
                                    onChange={date => handleDatePicker('fecha_inicio', date)}
                                />
                                <label className="label-datepicker" htmlFor="fecha_inicio">Inicio de búsqueda</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_fin"
                                    name="fecha_fin"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    selected={filtrosData.fecha_fin != null ? new Date(filtrosData.fecha_fin) : ''}
                                    onChange={date => handleDatePicker('fecha_fin', date)}
                                />
                                <label className="label-datepicker" htmlFor="fecha_fin">Fin de búsqueda</label>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <>
                            <button type="button" className="btn btn-primary" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Buscar todos</button>
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Buscar</button>
                        </>
                    :
                        <>
                            <button type="button" className="btn btn-primary" onClick={() => handleProcesar(true)}><i className="fas fa-search fa-sm"></i> Buscar todos</button>
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar(false)}><i className="fas fa-search fa-sm"></i> Buscar</button>
                        </>
                }
            </Modal.Footer>
        </Modal>
    );
}

export default FiltrosCitas;
